module.exports = __webpack_public_path__ + "static/img/logo-8.705b6cfc.png";